<template>
  <div
    ref="grid"
    class="grid">
    <div class="contact-sticky">
      <span @click="gotoInfo">
        Contact & Info
      </span>
    </div>
    <div
      ref="container"
      class="cases-container"
      v-if="!loading">
      <transition-group
        appear
        name="case-list"
        tag="div"
        class="cases"
        type="animation"
        :css="false"
        @before-enter="beforeEnter"
        @enter="enter">
        <div class="case"
          v-for="(c, idx) in filteredCases"
          :key="c.id"
          :data-index="idx"

          @click="setActive">
          <div class="overlay">
            <router-link :to="{ name: 'case', params: { slug: c.slug }}">
              <div class="name">
                {{ c.name }}
              </div>
            </router-link>
          </div>
          <MVMImage :width="950" :height="950" :img="c.cover" :sizeUrl="c.cover.sizes.crop_lg" :date="new Date(c.updated_at).getTime()" />
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { TweenMax, Sine, Power3 } from 'gsap'
import MVMImage from './MVMImage'
TweenMax.defaultEase = Sine.easeOut

export default {
  name: 'MVMCases',
  components: {
    MVMImage
  },
  props: {
    filter: {
      type: Array
    }
  },

  data () {
    return {
      $sticky: null,
      scrollDirection: null,
      lastScrollPos: 0,
      stickyActive: false,
      filteredCases: [],
      cases: [],
      loading: true
    }
  },

  watch: {
    filter (f, oldF) {
      // grab height of outer
      let cHeight = this.$refs.container.offsetHeight
      TweenMax.set(this.$refs.grid, { height: cHeight })

      TweenMax.to(this.$refs.container, 0.2, { opacity: 0,
        ease: Power3.easeIn,
        overwrite: true,
        onComplete: () => {
          this.filteredCases = []
          this.$nextTick()
            .then(() => {
              if (f.includes('all')) {
                this.filteredCases = [ ...this.cases ]
              } else {
                this.filteredCases = [
                  ...this.cases.filter(c => {
                    let caseTags = c.tags.map(function (x) { return x.toLowerCase() })
                    return f.every(tag => caseTags.includes(tag))
                  })
                ]
              }
              this.$nextTick().then(() => {
                TweenMax.to(this.$refs.container, 0.5, { opacity: 1,
                  ease: Power3.easeInOut,
                  onComplete: () => {
                    TweenMax.to(this.$refs.grid, 0.5, { height: this.$refs.container.offsetHeight, ease: Power3.easeInOut })
                  }
                })
              })
            })
        }
      })
    }
  },

  mounted () {
    window.onscroll = this.onScroll
    this.$sticky = document.querySelector('.contact-sticky')

    axios
      .get('/api/cases')
      .then(response => {
        this.cases = response.data.cases
        this.filteredCases = [...this.cases]
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => {
        this.loading = false
      })
  },

  methods: {
    gotoInfo (e) {
      this.hideSticky('fast', () => {
        this.$router.push('info')
      })
    },

    onScroll (e) {
      let grid = document.querySelector('.cases-container')
      if (!grid) {
        return
      }
      let gridTop = grid.offsetTop
      let scrollPos = document.documentElement.scrollTop || document.body.scrollTop

      this.scrollDirection = scrollPos > this.lastScrollPos ? 'down' : 'up'
      this.lastScrollPos = scrollPos

      if (gridTop >= scrollPos) {
        if (this.stickyActive) {
          this.hideSticky('slow', () => {})
        }
      } else {
        if (this.scrollDirection === 'up') {
          if (!this.stickyActive) {
            this.showSticky()
          }
        } else {
          if (this.stickyActive) {
            this.hideSticky('slow', () => {})
          }
        }
        // on the grid
      }
    },

    showSticky () {
      this.stickyActive = true
      TweenMax.set(this.$sticky, { display: 'block', y: '-100' })
      TweenMax.to(this.$sticky, 0.35, {
        y: '0',
        onComplete: () => {}
      })
    },

    hideSticky (speed, cb) {
      this.stickyActive = false
      let spd = speed === 'fast' ? 0.25 : 0.85

      TweenMax.to(this.$sticky, spd, {
        y: '-100',
        onComplete: () => {
          TweenMax.set(this.$sticky, { display: 'none' })
          if (cb) {
            cb.call()
          }
        }
      })
    },

    setActive (ev) {
      ev.currentTarget.classList.add('active')
    },

    beforeEnter (el) {
      TweenMax.set(el, { opacity: 0, y: -5 })
    },

    enter (el, done) {
      let delay = el.dataset.index * 75
      setTimeout(function () {
        TweenMax.to(el, 0.9, { opacity: 1, y: 0, onComplete: done })
      }, delay)
    },

    leave (el, done) {
      TweenMax.to(el, 0.1, {
        opacity: 0,
        y: -5,
        onComplete: () => {
          done()
        }
      })
    }
  }
}
</script>
